import { ISortByCol } from 'rad-coreframe-grid';
import { CustomFilterChip, FilterJson, GridColumn } from '#/DefaultViewExtensionInterfaces';
import FilterChipsViewModel from '@/Components/Filter/FilterChipsViewModel';
import FilterViewModel from '@/ViewModels/Controls/FilterViewModel';
import Utilities from '@/Utility/Utilities';
import FilterChipsHelper from '@/Components/Filter/FilterChipsHelper';

export default class FilterHelper {

    public hasCommunicationError: boolean;

    public static createFilterObjectForStaticFilter(staticFilter: string): FilterJson {
        return {
            components: [],
            sorting: [],
            staticFilter: staticFilter,
            lastExtentCount: 0,
        }
    }

    public static createFilterObject(staticFilter: string, preFilter: string, filter: FilterViewModel, customFilterChipData?: Array<CustomFilterChip>): FilterJson {
        let preFilterChipIsActive: boolean = false;
        let customFiltersActive: boolean = false;

        const activeChips = filter?.filterChipsViewModel?.activeChips;
        if (filter && filter.filterChipsViewModel) {
            preFilterChipIsActive = _.contains(activeChips(), FilterChipsViewModel.getPreFilterLabel());

            customFiltersActive = activeChips().filter((entry) => FilterChipsHelper.isCustom(entry)).length > 0;
        }

        let filterExpressionObject = {} as FilterJson;
        if (!Utilities.isNullOrUndefined(filter))
            filterExpressionObject = JSON.parse(JSON.stringify(filter.filterExpressionObject())); // Klonen


        if (staticFilter) {
            filterExpressionObject.staticFilter = staticFilter;
        }

        if (preFilterChipIsActive) {
            if (Utilities.isNotBlank(staticFilter))
                filterExpressionObject.staticFilter = filterExpressionObject.staticFilter + " and " + preFilter;
            else
                filterExpressionObject.staticFilter = preFilter;
        }

        if (customFilterChipData && customFiltersActive && activeChips) {
            const statements = [];
            const relevantFilter = customFilterChipData.filter(chip => activeChips().includes(FilterChipsHelper.addCustomPrefix(chip.displayName)));
            for (let customChipData of relevantFilter) 
                statements.push(customChipData.filterTerm);

            if (Utilities.isNotBlank(staticFilter))
                filterExpressionObject.staticFilter = filterExpressionObject.staticFilter + " and " + statements.join(" and ");
            else
                filterExpressionObject.staticFilter = statements.join(" and ");
        }

        if (_.isEmpty(filterExpressionObject.components) && Utilities.isBlank(filterExpressionObject.staticFilter)) {
            return {} as FilterJson;
        }

        return filterExpressionObject;
    }

    public static createOrderExpression(order: ISortByCol[], columns: GridColumn[], associationName: string, defaultOrder: string): string {
        let prefix = associationName ? 'this.' + associationName + '.' : 'this.';

        if (order != null && order.length > 0) {
            let expressions = [];

            for (let i = 0; i < order.length; i++) {
                for (let j = 0; j < columns.length; j++) {
                    if (columns[j].field === order[i].field) {
                        let replace = (columns[j].uiGenerator as any) === 'CurrencyTextBox' ? '.EURValue' : '.Value';
                        expressions.push(prefix + columns[j].name.replace(/\.ListViewValue/, replace) + ' ' + order[i].dir);
                    }
                }
            }

            return expressions.join(', ');
        }

        return defaultOrder;
    }
}